import AboutStyle from '@/styles/components/careers/add-section/_index.module.scss';

export function AboutSection({formik, sidebar_section, customizeCareerAction}){
  return(
    <div className = {`${AboutStyle.About}`}>
      <label className = {`${AboutStyle.About__Title}`}>About</label>
      <div className = {`${AboutStyle.About__FirstOption}`} onClick={(event) => {
            customizeCareerAction.addSection(formik, 'about', 'with_image')
          }}>
        <div className = {`${AboutStyle.About__LeftContent}`}>
          <div className = {`${AboutStyle.About__Image}`}>
            <img src = '/images/pages/career/about.jpg'></img>
          </div>
        </div>
        <div className = {`${AboutStyle.About__RightContent}`}>
          <div className = {`${AboutStyle.About__SubTitle}`}>
            <h3>{sidebar_section.about.title}</h3>
          </div>
          <div className = {`${AboutStyle.About__Para}`}>
            <p>{sidebar_section.about.description}</p>
          </div>
        </div>
        <div className = {`${AboutStyle.About__AddBtn} noAddbtn__Inreorder`}>
          <span>Add</span>
        </div>
      </div>
    </div>
  )
}